import { MButton } from '@assets/mui/@material-extend';
import SettingsDoubleIcon from '@components/icons/SettingsDoubleIcon';
import CardWrapper from '@components/UI/CardWrapper';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ChangeNotificationStyledContainer } from './StyledComponent';

interface ChangeNotificationProps {
  isOpen: boolean;
  needReviewType: boolean;
  onClose: () => void;
}

function ChangeNotification({ isOpen, needReviewType, onClose }: ChangeNotificationProps) {
  const { t } = useTranslation('CompanyProfile');

  return (
    <Dialog
      maxWidth={false}
      open={isOpen}
      onClose={onClose}
      scroll={'body'}
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '465px',
          },
        },
      }}
    >
      <ChangeNotificationStyledContainer>
        <CardWrapper sx={{ padding: '40px' }} className="card">
          <Box className="close-button">
            <IconButton onClick={onClose}>
              <CloseIcon fontSize="small" sx={{ color: '#383838' }} />
            </IconButton>
          </Box>
          <CardWrapper
            sx={{ padding: '22px', maxWidth: 'max-content' }}
            className="settings-wrapper"
          >
            <SettingsDoubleIcon />
          </CardWrapper>
          <Typography variant={'h3'} className={'notification-title'}>
            {needReviewType
              ? t('CompanyProfile:ChangeNotification.ChangesSentForReview')
              : t('CompanyProfile:ChangeNotification.ChangesSavedSuccessfully')}
          </Typography>
          <MButton
            className={'close-notification-button'}
            variant={'contained'}
            color={'secondary'}
            onClick={onClose}
          >
            <Typography color={'white'} fontSize={16} fontWeight={600}>
              {t('CompanyProfile:ChangeNotification.ReturnToSiteButton')}
            </Typography>
          </MButton>
        </CardWrapper>
      </ChangeNotificationStyledContainer>
    </Dialog>
  );
}

export { ChangeNotification };
